"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** Unique string for svg */
  unique: _propTypes.string
};
var defaultProps = {
  unique: ""
};

var Search = function Search(_ref) {
  var unique = _ref.unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.4167979,16.00015 C10.3787979,16.00015 7.91679789,13.53815 7.91679789,10.50015 C7.91679789,7.46215 10.3787979,5.00015 13.4167979,5.00015 C16.4537979,5.00015 18.9167979,7.46215 18.9167979,10.50015 C18.9167979,13.53815 16.4537979,16.00015 13.4167979,16.00015 M8.92069197,16.4935216 L4.56066017,20.8535534 C4.36539803,21.0488155 4.04881554,21.0488155 3.85355339,20.8535534 L3.14644661,20.1464466 C2.95118446,19.9511845 2.95118446,19.634602 3.14644661,19.4393398 L7.49369325,15.0920932 C6.50732577,13.8214322 5.91679789,12.2295447 5.91679789,10.50015 C5.91679789,6.36415 9.28079789,3.00015 13.4167979,3.00015 C17.5517979,3.00015 20.9167979,6.36415 20.9167979,10.50015 C20.9167979,14.63515 17.5517979,18.00015 13.4167979,18.00015 C11.7296036,18.00015 10.1746074,17.4367127 8.92069275,16.4935208 Z",
    fill: "inherit",
    id: "path-1-search" + unique
  })), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "Glyphs/Nav/*Search",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Nav_Anonymous",
    transform: "translate(-1379.000000, -31.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Nav"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Glyphs/Nav/*Search",
    transform: "translate(1376.000000, 28.000000)"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "page-1-search" + unique,
    xlinkHref: "#path-1-search" + unique
  }))))));
};

Search.propTypes = propTypes;
Search.defaultProps = defaultProps;
var _default = Search;
exports["default"] = _default;